module.exports = __webpack_public_path__ + "producr-dried fresh-grass-09.jpg?6c6f389ea98877e46333d4ab12524a1d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-09.jpg
// module id = 67
// module chunks = 0